import React, { useState, useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { downloadDoc } from '../../../../services/documentsService';

import { PDF, POPUP } from '../../../../../redux/types';

import { IDocumentsCell } from '../../../types/IDocumentsCell';

import { Tooltip } from '@progress/kendo-react-tooltip';
import LoadingCell from '../../../../ui/table/cells/loadingCell/loadingCell';

import './documentNameCell.scss';

const DocumentNameCell: React.FC<IDocumentsCell> = ({
                                                      rowType,
                                                      dataItem,
                                                      field,
                                                      origin,
                                                      idField,
                                                      icon,
                                                      className,
                                                      style,
                                                      alterField,
                                                    }) => {
  const [isRead, setIsRead] = useState<boolean>(dataItem.isRead);

  const dispatch = useDispatch();

  if (rowType === 'groupHeader') {
    return null;
  }

  let nameColField = !dataItem[field] ? dataItem[alterField] : dataItem[field];
  if (nameColField === undefined) return <LoadingCell />;

  const updateIsReadFlag = (isRead) => {
    setIsRead(isRead);
    dataItem.isRead = isRead;
  };

  useEffect(() => {
    setIsRead(dataItem.isRead);
  }, [isRead]);

  return (
    <td className={`${className} document-cell`} style={style}>
      <Tooltip anchorElement='target'>
        <div className='document-name-wrapper'>
          {icon}
          {dataItem.fileType.toLowerCase() === 'pdf' ? (
            <div className="pointer name-container" onClick={() => dispatch({ type: PDF.SHOW_PDF_DIALOG, payload: dataItem[idField || 'id']})}>
              <span
                title={nameColField}
                style={{ fontWeight: !isRead ? 'bold' : 'normal' }}
                onClick={() => {
                  updateIsReadFlag(true);
                }}>
                {nameColField}
              </span>
            </div>
          ) : (
            <span style={{ fontWeight: !isRead ? 'bold' : 'normal' }}
                  className="pointer"
                  onClick={() => downloadDoc(dataItem).catch((err) => dispatch({
                    type: POPUP.SET_SERVER_ERROR,
                    payload: err.message,
                  }))}>
              {nameColField}
            </span>
          )}
        </div>
      </Tooltip>
    </td>
  );
};

export default DocumentNameCell;
